export const maxWidth = '1022px'
export const maxWidthTablet = '637px'
export const maxWidthMobile = '100vw'

export const xPaddingMobile = '55px'
export const xPaddingTablet = '90px'

export const navHeight = '67px'
